import React from 'react'
import PropTypes from 'prop-types'
import { Controller, useForm } from 'react-hook-form'
import { Box, TextField, Typography } from '@material-ui/core'

import { DialogLayout } from 'components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import schema from './schema'
import theme from 'theme'

const DialogRevertLia = ({
  open,
  setOpen,
  dataProcess,
  setLoading,
  refresh,
}) => {
  const snackbar = useSnackbar()

  const { handleSubmit, errors, control } = useForm({
    validationSchema: schema,
    defaultValues: {
      reason: '',
    },
  })

  const onSubmit = async (data) => {
    try {
      setLoading(true)

      await service.dponet.dataProcesses.revertLia({
        dataProcessId: dataProcess.id,
        ...data,
      })

      snackbar.open({
        message: 'LIA revertido com sucesso!',
        variant: 'success',
      })
      refresh()
      setOpen(false)
    } catch (error) {
      console.error(error)
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Ocorreu um erro ao tentar reverter o LIA!',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <DialogLayout
      open={open}
      setOpen={setOpen}
      title="Reverter LIA"
      confirmTextButton="Reverter"
      handleSubmit={handleSubmit(onSubmit)}
    >
      <Box
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(2)}
        textAlign="justify"
      >
        <Typography>
          Tem certeza que deseja reverter o LIA? Ao reverter, o processo de
          Avaliação de Legítimo Interesse (LIA) será desfeito e retornará para a
          etapa anterior.
        </Typography>
        <Typography>
          Todas as informações e ações realizadas durante a avaliação do LIA
          serão salvas, porém, caso o processo não volte a se enquadrar como LIA
          no futuro, esses dados deixarão de ser utilizados.
        </Typography>
        <Typography>Para prosseguir, informe o motivo da reversão.</Typography>
        <Controller
          control={control}
          name="reason"
          as={
            <TextField
              label="Motivo da reversão"
              variant="outlined"
              error={!!errors?.reason}
              helperText={errors?.reason?.message}
              minRows={4}
              maxRows={4}
              fullWidth
              multiline
              required
            />
          }
        />
      </Box>
    </DialogLayout>
  )
}

DialogRevertLia.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  dataProcess: PropTypes.object.isRequired,
  setLoading: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
}

export default DialogRevertLia
